<template>
    <div style="padding-bottom: 100px">
        <div class="operations" style="justify-content: right">
            <div style="margin-right: auto;">
                <span class="t">查询结果</span>
                <span style="color: rgba(32, 147, 202, 1)" class="t">共{{ total ? total : 0 }}颗</span>
            </div>
            <div class="submit reset" @click="showForm">修改参数</div>
            <a href="https://work.weixin.qq.com/kfid/kfc875a6ce213fef2dc" target="_blank" class="submit query" @click="">咨询客服</a>
        </div>
        <div class="list">
            <el-table
                :data="data"
                header-cell-class-name="table-head"
                highlight-current-row
                max-height="700"
                :row-class-name="setRowClass"
                cell-class-name="table-cell"
                @row-click="handleRowClick"
                ref="diamondTable"
                style="width: 100%">
                <el-table-column label="位置" prop="position"></el-table-column>
                <el-table-column label="形状" prop="shape"></el-table-column>
                <el-table-column label="钻重(ct)" prop="weight"></el-table-column>
                <el-table-column label="颜色" prop="color"></el-table-column>
                <el-table-column label="切工">
                    <template slot-scope="scope">
                        {{ scope.row.cut ? scope.row.cut : '-' }}/{{
                            scope.row.polish ? scope.row.polish : '-'
                        }}/{{ scope.row.symm ? scope.row.symm : '-' }}
                    </template>
                </el-table-column>
                <el-table-column label="净度" prop="clarity"></el-table-column>
                <el-table-column label="荧光" prop="fls"></el-table-column>
                <el-table-column label="奶咖色">
                    <template slot-scope="scope">
                        {{ scope.row.coffee }} {{ scope.row.cream }}
                    </template>
                </el-table-column>
                <el-table-column width="140" label="尺寸(mm)" prop="size"></el-table-column>
                <el-table-column label="证书" prop="gia"></el-table-column>
                <el-table-column width="120" label="证书号">
                    <template slot-scope="scope">
                        <div style="color: rgba(32, 147, 202, 1);">
                            {{ scope.row.crtificate_no }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="价格(￥)">
                    <template slot-scope="scope">
                        <div style="color: rgba(242, 82, 82, 1);">
                            {{ scope.row.rmb * 1 }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <div onMouseOver="this.style.cursor='pointer'" style="color: rgba(32, 147, 202, 1);" @click="copyData(scope.row)">复制参数
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div style="float: right;margin: 20px 0;">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handlePageChange"
                :current-page.sync="params.page"
                :page-size="params.per_page"
                layout="prev, pager, next, jumper"
                prev-text="上一页"
                next-text="下一页"
                :total="total"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import {diamondList} from "@/api/api";

export default {
    name: 'diamondList',
    data() {
        return {
            total: 0,
            currentRow: null,
            data: [],
        }
    },
    props: {
        params: {
            type: Object,
            default: {}
        }
    },
    created() {
        this.params.page = 1
        this.readList()
    },
    mounted() {
    },
    methods: {
        showForm() {
            this.$emit('showForm')
        },
        copyData(data) {
            this.$copyText([
                "形状：" + data.shape,
                "地点：" + data.position,
                "重量：" + data.weight,
                "颜色：" + data.color,
                "净度：" + data.clarity,
                "切工：" + data.cut,
                "打磨：" + data.polish,
                "对称：" + data.symm,
                "荧光：" + data.fls,
                "尺寸：" + data.size,
                "证书：" + data.gia + '-' + data.code,
                "肉眼：" + data.situation,
                "No BGM - " + data.cream + ' ' + data.coffee,
            ].join('\n')).then(e => {
                this.$message.success('复制成功')
            }, e => {
                this.$message.error('复制失败')
            })
        },
        handleRowClick(val) {
            if (this.currentRow === val) {
                this.currentRow = null
                this.$refs.diamondTable.setCurrentRow(null);
            } else {
                this.currentRow = val
            }
        },
        setRowClass(row) {
            if (row.rowIndex % 2) {
                return 'row-even'
            }
        },
        handleSizeChange(e) {
            this.params.per_page = e
            this.readList()
        },
        handlePageChange(e) {
            this.params.page = e
            this.readList()
        },
        readList() {
            return diamondList(this.params).then(res => {
                if (res.data.code === 1000) {
                    this.data = res.data.data
                    if (!this.total) {
                        this.total = res.data.count * 1
                    }
                } else {
                    this.total = 0
                    this.$message.error('网络错误，请稍后再试')
                }
            })
        },
    },
    watch: {}
}
</script>

<style lang="scss">
@import "diamondList";
</style>